import "./TabelaExtrato.css";

const TabelaExtrato = ({ itensLista = [], loading = false, children }) => {
  const itens = Array.isArray(itensLista) ? itensLista : [];

  const formatCurrencyBRL = (value) => {
    const n = Number(value || 0);
    return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  };

  const formatarDataBRL = (data) => {
    if (!data) return "-";
    const d = new Date(data);
    if (isNaN(d.getTime())) return "-";
    const dia = String(d.getDate()).padStart(2, "0");
    const mes = String(d.getMonth() + 1).padStart(2, "0");
    const ano = d.getFullYear();
    return `${dia}/${mes}/${ano}`;
  };

  const renderizarStatus = (status) => {
    switch (status) {
      case "CONFIRMED":
        return <span className="status-pill status-credito">Confirmado</span>;
      case "PENDING":
        return <span className="status-pill status-analise">Aguardando confirmação</span>;
      case "WITHDRAW_REQUESTED":
        return <span className="status-pill status-saque-solicitado">Saque solicitado</span>;
      default:
        return <span className="status-pill">-</span>;
    }
  };

  return (
    <section className="table-card">
      <div className="table-title">{children}</div>

      <div className="table-tr">
        <table>
          <thead>
            <tr>
              <th>Data</th>
              <th>Nº compra</th>
              <th>Cliente</th>
              <th>Valor compra</th>
              <th>Valor comissão</th>
              <th>Tipo</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody id="extratoTableBody">
            {loading && (
              <tr>
                <td colSpan={7} style={{ textAlign: "center" }}>
                  Carregando...
                </td>
              </tr>
            )}

            {!loading && itens.length === 0 && (
              <tr>
                <td colSpan={7} style={{ textAlign: "center" }}>
                  Nenhum lançamento encontrado
                </td>
              </tr>
            )}

            {!loading &&
              itens.map((item) => {
                const isSaque = item.origin === "WITHDRAW";

                // ✅ CONSISTÊNCIA: seu backend salva purchase_amount em reais (Number)
                const purchaseAmount = Number(item.purchase_amount) || 0;
                const commissionPercent = Number(item.commission_percent) || 0;

                // comissão em reais (sem /100)
                const commissionValue = (purchaseAmount * commissionPercent) / 100;

                // saque mostra negativo (igual admin)
                const commissionFinal = isSaque ? -purchaseAmount : commissionValue;

                // ✅ data do extrato deve ser entry_date (respeita programados)
                const dataLinha = item.entry_date || item.created_at;

                return (
                  <tr key={item.id}>
                    <td>{formatarDataBRL(dataLinha)}</td>
                    <td>{item.order_number || "-"}</td>
                    <td>{item.client_name || "-"}</td>

                    <td>{formatCurrencyBRL(purchaseAmount)}</td>
                    <td>{formatCurrencyBRL(commissionFinal)}</td>

                    <td className={isSaque ? "tipo-debito" : "tipo-credito"}>
                      {isSaque ? "Débito" : "Crédito"}
                    </td>

                    <td>{renderizarStatus(item.status)}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default TabelaExtrato;
